import ActionType from "../../types/ActionType"
import { NotePerson, NotePersonItem } from "../../types/NotePersonType"
import { Person } from "../../types/PersonType"
import NotesPersonActions from "../actions/notesPerson"

export enum CreateNotePersonStatus {
  PRISTINE = 0,
  SUBMITTING,
  SUCCESS,
  ERROR,
}

export interface NotesPersonStore {
  createNotePersonStatus: CreateNotePersonStatus
  errorMessage: string
  loadingCreateNotePerson: boolean
  loadingNotesPerson: boolean
  loadingNotePersonById?: boolean
  loadingNotesPersonList: boolean
  notePerson: NotePerson | null
  noteAuthorPerson?: Person | null
  notesPerson: NotePersonItem[]
  notesPersonList: NotePersonItem[]
  totalPagesNotesPerson: number
  downloadedNotes: string | null
}

const INITIAL_STATE: NotesPersonStore = {
  createNotePersonStatus: CreateNotePersonStatus.PRISTINE,
  errorMessage: "",
  loadingCreateNotePerson: true,
  loadingNotesPerson: true,
  loadingNotePersonById: false,
  loadingNotesPersonList: false,
  notePerson: null,
  noteAuthorPerson: null,
  notesPerson: [],
  notesPersonList: [],
  totalPagesNotesPerson: 1,
  downloadedNotes: null,
}

export default (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case NotesPersonActions.FETCH_NOTES_PERSON_TRIGGER: {
      return {
        ...state,
        loadingNotesPerson: true,
      }
    }

    case NotesPersonActions.FETCH_NOTES_PERSON_SUCCESS: {
      return {
        ...state,
        loadingNotesPerson: false,
        totalPagesNotesPerson: action.payload.pager?.totalPages || 0,
        notesPerson: action.payload.rows,
      }
    }

    case NotesPersonActions.FETCH_NOTES_PERSON_ERROR: {
      return {
        ...state,
        loadingNotesPerson: false,
        errorMessage: action.payload,
      }
    }
    case NotesPersonActions.FETCH_ALL_NOTES_PERSON_TRIGGER: {
      return {
        ...state,
        loadingNotesPersonList: true,
      }
    }

    case NotesPersonActions.FETCH_ALL_NOTES_PERSON_SUCCESS: {
      return {
        ...state,
        loadingNotesPersonList: false,
        totalPagesNotesPerson: action.payload.pager?.totalPages || 0,
        notesPersonList: action.payload.rows,
      }
    }

    case NotesPersonActions.FETCH_ALL_NOTES_PERSON_ERROR: {
      return {
        ...state,
        loadingNotesPersonList: false,
        errorMessage: action.payload,
      }
    }

    case NotesPersonActions.FETCH_NOTE_PERSON_BY_ID_TRIGGER: {
      return {
        ...state,
        loadingNotePersonById: true,
      }
    }

    case NotesPersonActions.FETCH_NOTE_PERSON_BY_ID_SUCCESS: {
      return {
        ...state,
        loadingNotePersonById: false,
        notePerson: action.payload,
      }
    }

    case NotesPersonActions.FETCH_NOTE_PERSON_BY_ID_ERROR: {
      return {
        ...state,
        loadingNotePersonById: false,
        errorMessage: action.payload,
      }
    }

    case NotesPersonActions.FETCH_NOTE_AUTHOR_BY_ID_TRIGGER: {
      return {
        ...state,
        // no dedicated loading UI needed; keep simple
      }
    }

    case NotesPersonActions.FETCH_NOTE_AUTHOR_BY_ID_SUCCESS: {
      return {
        ...state,
        noteAuthorPerson: action.payload,
      }
    }

    case NotesPersonActions.FETCH_NOTE_AUTHOR_BY_ID_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
      }
    }

    case NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_TRIGGER: {
      return {
        ...state,
        downloadedNotes: NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_TRIGGER,
      }
    }

    case NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_SUCCESS: {
      return {
        ...state,
        downloadedNotes: NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_SUCCESS,
      }
    }

    case NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_ERROR: {
      return {
        ...state,
        downloadedNotes: NotesPersonActions.DOWNLOAD_ALL_NOTES_PERSON_ERROR,
      }
    }

    case NotesPersonActions.CLEAR_DOWNLOAD_ALL_NOTES_PERSON: {
      return {
        ...state,
        downloadedNotes: NotesPersonActions.CLEAR_DOWNLOAD_ALL_NOTES_PERSON,
      }
    }

    case NotesPersonActions.CREATE_NOTES_PERSON_TRIGGER: {
      return {
        ...state,
        createNotePersonStatus: CreateNotePersonStatus.SUBMITTING,
        loadingCreateNotePerson: true,
      }
    }

    case NotesPersonActions.CREATE_NOTES_PERSON_SUCCESS: {
      return {
        ...state,
        createNotePersonStatus: CreateNotePersonStatus.SUCCESS,
        loadingCreateNotePerson: false,
        notePerson: action.payload,
      }
    }

    case NotesPersonActions.CREATE_NOTES_PERSON_ERROR: {
      return {
        ...state,
        createNotePersonStatus: CreateNotePersonStatus.ERROR,
        loadingCreateNotePerson: false,
        errorMessage: action.payload,
      }
    }

    case NotesPersonActions.CLEAR_NOTES_PERSON:
      return INITIAL_STATE

    default:
      return state
  }
}
